import { Form } from "antd";
import { HeaderOverview } from "components";
import { LoadingDashboard, WrapperBG, checkDataObject } from "pages/overview";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardParcelByStatus } from "service/dashboard/central/parcel";

const ParcelStill = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const parcelsStillDate = Form.useWatch("parcelsStillDate");
  const date = findDate(parcelsStillDate);

  const { data, isFetching } = useGetDashboardParcelByStatus({
    ...date,
    property,
  });

  const findData = checkDataObject(data);
  const notReceived = findData?.notReceived || 0;
  const overtime = findData?.overTime || 0;
  const sendback = findData?.sendback || 0;

  const count = (notReceived + overtime + sendback).toLocaleString();

  return (
    <WrapperBG className="h-[300px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("number-of-parcels-still")}
          name="parcelsStillDate"
        />
        <div className="h-[200px] center flex-col">
          <div className="text-[2.5rem] text-[#44955B]">{count}</div>
          <div className="text-[1.5rem] text-[#276347]">{t("pieces")}</div>
        </div>
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default ParcelStill;
